import React from 'react';
import { useQueryClient } from 'react-query';
import _ from "underscore";
import moment from "moment/moment";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import {Box} from "@material-ui/core";
import useCostings from '../../../services/costings/useCostings';

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
});

const defaultSearch = {
  costingNumber: null,
  fromDate: moment().startOf('day').subtract(120, 'day').toISOString(),
  toDate: moment().endOf('day').toISOString(),
  origin: "",
  destination: "",
  refresh: 0
};

const formatInputValue = (value, records) => {
  let inputValue= value||"";
  if (records.data) {
    const searchValue = inputValue.replace(/[^0-9]/g,"");
    const costingData = _.find(records.data, {costingNumber: Number(searchValue)});
    if (costingData) {
      let costingNumber = costingData.costingNumber;
      if (inputValue.startsWith("UCN"))
        inputValue = `UCN-${costingNumber}`;
      else
        inputValue = `${costingNumber}`;
    }
  }
  return inputValue;
}

const ContractCostingUuidLookup = props => {

  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    }
  }))(theme);

  const queryClient = useQueryClient();
  const extraKeys = [];
  const allRecords = useCostings({queryClient, useCache: false, extraKeys, params: {...defaultSearch, companyUuid: props.companyUuid, costingUuid: props.value}, rowCount: 300});
  const records = allRecords?{...allRecords}:allRecords;

  const handleChange = (event, record) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = props.allowEmpty ? { value: null, found: true, data: {costingNumber: "", companyUuid: null} } : { value: null, found: false, data: {} }
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
        returnObject.value = record.costingUuid;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.costingUuid);
      }
    }
  }
  const handleInputChange = (event, value) => {
    if (!event || (event.type !== 'change' && !((event.type === 'blur' || event.type==='click') && (value || props.allowEmpty)))) return;
    if (props.returnType === "object") {
      const returnObject = props.allowEmpty ? { value: value, found: true, data: {costingNumber: "", costingUuid: value} } : { value: value, found: false, data: {} }
      const record = _.findWhere(records.data, { costingUuid: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
        returnObject.value = record.costingUuid;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(value);
    }
  }

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  const defaultFilterOptions = (options, state) => {
    if (state.inputValue) {
      if (state.inputValue.length === 36) {
        return _.filter(options, (costing) => {
          return (costing.costingUuid === state.inputValue)
        });
      }
      const searchCode = state?.inputValue?.replace(/[^0-9]/g,"");
      return _.filter(options, (costing) => {
        const costingNumber = `${costing.costingNumber}`||"";
        return (costingNumber.startsWith(searchCode))
      });
    } else return options.slice(0, 300);
  }
  const filterOptions = props.filterOptions || defaultFilterOptions;

  if (props.type === "render") {
    if (records.data && _.find(records.data, {costingUuid: props.value})) {
      const costing = _.find(records.data, {costingUuid: props.value});
      if (props.hideCode) {
        return <div>{costing.costingNumber} {moment(costing.costingDate).format("DD MMM")} - {costing.tripRouting}</div>
      }
      return <div>UCN-{costing.costingNumber} {moment(costing.costingDate).format("DD MMM")} - {costing.tripRouting}</div>
    }
    return <div>''</div>
  } else {
    return (
      <Autocomplete
        id={props.id}
        disableClearable={props.disableClearable === undefined ? true : props.disableClearable}
        autoSelect={(records && records.data && !props.allowEmpty)?true:false}
        // autoSelect={false}
        autoHighlight={true}
        inputValue={formatInputValue(props.value, records)}
        options={records.data||[]}
        filterOptions={filterOptions}
        PopperComponent={DropdownList}
        getOptionSelected={(option, value) => option.costingUuid === value.costingUuid}
        getOptionLabel={(option) => option.costingUuid}
        onChange={handleChange}
        onInputChange={handleInputChange}
        disabled={props.disabled||props.readOnly}
        renderOption={(option) => {
          return (
            <React.Fragment key={`costing-lookup-${option.costingNumber}`}>
              UCN-{option.costingNumber} {moment(option.costingDate).format("DD MMM")} - {option.tripRouting}
            </React.Fragment>
          )
        }}
        style={{
          width: (props.width||"100%"),
        }}
        renderInput={(params) => {
          let value = params.inputProps.value||"";
          const record = _.find(records.data, {costingUuid: value});
          if (record) {
            value = record.costingNumber ?`UCN-${record.costingNumber} (${record.tripRouting})` : "";
          }
          const extraProps = {};
          if (props.readOnly) {
            extraProps.className = classes.readOnly;
          }
          const inputProps = {
            ...props.inputProps,
            ...params.inputProps,
            ...extraProps,
            value
          }
          return (<TextField
            {...params}
            label={props.label}
            placeholder={props.placeHolder}
            inputProps={{...inputProps}}
            InputLabelProps={{shrink: props.shrink}}
          />)
        }}
      />
    )
  }
}

export default withStyles(styles) (ContractCostingUuidLookup);
export {
  ContractCostingUuidLookup
}
